<section>
    <div class="chat-item">
        <button [attr.aria-label]="pageData.name" type="button" (click)="openChat()" (mouseenter)="mouseHoverEvent($event)" (mouseleave)="mouseHoverEvent($event)">
            <xm-media-image [imageOptions]="displayIcon" size="height" class="icon"></xm-media-image>
            <span class="chat-name">{{ pageData.name }}</span>
        </button>
    </div>
</section>
